/**
 * Created by zqy on 2018/8/20 0020.
 */
import axios from 'axios'
import { Message,MessageBox} from 'element-ui'
import Qs from 'qs'
import store from '@/store'
import config from '@/config'

// 请求接口host
let _apiHost = config.api
let _requestFormData=config.requestFormData
let _responseSuccess=config.successCode

// create an axios instance
const service = axios.create({
  baseURL:_apiHost,// api的base_url
  timeout: 120000, // request timeout
  // responseType:"json"
})
// request interceptor
service.interceptors.request.use(config => {
  if(_requestFormData){
    if(config.contentType == 'json'){
      config.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
      config.headers.post['Content-Type'] = 'application/json'
    }else {
      //以下请求头Content-Type配置，设置Form Data(序列化参数)提交
      config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'//设置Form Data提交
    }
  }else{
    //以下请求头Content-Type配置为，设置JSON格式参数提交
    config.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers.post['Content-Type'] = 'application/json'
  }

  if (store.getters.token) {
    // 让每个请求携带token ['token']为自定义key 请根据实际情况自行修改
    config.headers['token'] = store.getters.token
  }

  if(config.method.toLowerCase() == "post"){
    if(config.contentType !== 'json'){
      config.data = Qs.stringify(config.data)
    }
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  //response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.code != _responseSuccess) {
      // 401:账号已冻结 ;50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 401 || res.code===50008 || res.code === 50012 || res.code === 50014) {
        // 请自行在引入 MessageBox
        // import { Message, MessageBox } from 'element-ui'
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
        return Promise.reject('error')
      }

      if(res.msg){
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }

      return response.data
    } else {
      return response.data
    }
  },
  error => {
    // 这里是返回状态码不为200时候的错误处理
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误(400)' ; break;
        case 401:
          //清除token信息并跳转到登录页面
          error.message = '未授权，请重新登录(401)';
          MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
          return Promise.reject('error')
          break;
        case 403: error.message = '拒绝访问(403)'; break;
        case 404: error.message = `请求出错(404)`; break;
        case 408: error.message = '请求超时(408)'; break;
        case 500: error.message = '服务器错误(500)'; break;
        case 501: error.message = '服务未实现(501)'; break;
        case 502: error.message = '网络错误(502)'; break;
        case 503: error.message = '服务不可用(503)'; break;
        case 504: error.message = '网络超时(504)'; break;
        case 505: error.message = 'HTTP版本不受支持(505)'; break;
        default: error.message = `连接出错(${error.response.status})!`;
      }
      error.code=error.response.status;
      console.log(`${error.response.config.url}`);
    }else{
      error.message = '连接服务器失败!'
      error.code='error';
    }
    console.log(`${error.message}`);// for debug
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js